export default __webpack_public_path__ + "static/aesi-28b2b2f74f909cb7cdec409f2d97fa8e.png";